const confirmBonusClaimModalStyles = {
    container: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-white max-w-[90%] sm:max-w-[450px] text-black min-w-[300px] px-[10px] py-[20px] sm:px-[20px]
    `,
    closeIconContainer: `absolute top-2 right-2 cursor-pointer`,
    redeem_rewards: `w-full h-auto max-w-[46px]`,
    popupheading: `flex items-center w-full gap-[12px] mb-[15px]`,
    highlightedText: `font-[700] text-primaryHeading`,
    heading: `text-[20px] font-[600] text-themeColor
              sm:text-[24px]
    `,
    description: `text-[14px] mb-[20px] text-themeColor
                  sm:text-[16px]
    `,
    buttonContainer: `flex flex-col w-full gap-2
                      sm:flex-row 
    `,
    button: `rounded-[4px] !text-[16px] w-full`,
    button1: `min-w-[48%] !bg-white !text-themeColor !border-gray-300 hover:!bg-gray-100`
}

export { confirmBonusClaimModalStyles }